/* eslint-disable max-len */
import GOVIcon from '../../../../../assets/governance.png';
import {
  smeBusinessStrategyQuestions,
  smeDisclosureQuestions,
  smeGovernanceQuestions,
  smeIntroQuestions,
  smeManagementQuestions,
  smePerformanceClimateChangeQuestions,
  smePerformanceConsolidationApproachQuestions,
  smeSignOffQuestions
} from '../../../../../components/Forms/Constants/CDP/SME/smeQuestions';
import {getCdpUrl} from '../utils/utils';

export const pillers = {
  smeIntroduction: 'pillar_sme_introduction',
  smeManagement: 'pillar_sme_management',
  smeDisclosure: 'pillar_sme_disclosure',
  smeGovernance: 'pillar_sme_governance',
  smeBusinessStrategy: 'pillar_sme_business_strategy',
  smePerformanceConsolidationApproach: 'pillar_sme_performance_consolidation_approach',
  smePerformanceClimateChange: 'pillar_sme_performance_climate_change',
  smeSignOff: 'pillar_sme_sign_off'
};

export const smeIntroTabQuestions = {
  pillarId: pillers.smeIntroduction,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Introduction',
    description: `This module requests information about the organization’s disclosure 
    to CDP and will help data users interpret responses in the context of the organization’s 
    business operations, timeframe, and entities included in their CDP response. `,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeIntroduction),
  tabs: [
    {
      id: 'tab_smeIntroduction',
      title: 'SME Introduction',
      questions: smeIntroQuestions,
      accordion: false
    }
  ]
};

export const smeManagementTabQuestions = {
  pillarId: pillers.smeManagement,
  header: {
    imageUrl: GOVIcon,
    title:
      'SME Identification, Assessment and Management of Risks and Opportunities',
    description:`This module requests information about the procedures that organizations
     have in place to identify, assess, and manage their environmental-related risks and opportunities.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeManagement),
  tabs: [
    {
      id: 'tab_smeManagement',
      title:
        'SME Identification, Assessment and Management of Risks and Opportunities',
      questions: smeManagementQuestions,
      accordion: false
    }
  ]
};

export const smeDisclosureTabQuestions = {
  pillarId: pillers.smeDisclosure,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Disclosure of Risks and Opportunities',
    description: `This module requests information on risks related to environmental issues, which have had a
     substantive effect on the organization in the reporting year or may in the future, and details of the
      potential effects of those risks and their associated response strategies. It also requests information 
      on any environmental opportunities created by environmental issues which have had a substantive effect
       on the organization in the reporting year or may in the future. `,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeDisclosure),
  tabs: [
    {
      id: 'tab_smeDisclosure',
      title: 'SME Disclosure of Risks and Opportunities',
      questions: smeDisclosureQuestions,
      accordion: false
    }
  ]
};

export const smeGovernanceTabQuestions = {
  pillarId: pillers.smeGovernance,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Governance',
    description: `This module requests information on the highest positions or committees with responsibility
     for environmental issues and environmental policies in your organization.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeGovernance),
  tabs: [
    {
      id: 'tab_smeGovernance',
      title: 'SME Governance',
      questions: smeGovernanceQuestions,
      accordion: false
    }
  ]
};

export const smeBusinessStrategyTabQuestions = {
  pillarId: pillers.smeBusinessStrategy,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Business Strategy',
    description: `This module requests information on the effects of risks and opportunities on 
                 financial and strategic planning, transition plans (a tool for organizations to
                 understand strategic implications of environmental risks and opportunities), 
                 and engagement with suppliers, customers, and other stakeholders on environmental issues. 
                 The module also contains questions on collaborative opportunities, shown only to organizations
                  responding to a request from a CDP Supply Chain member.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeBusinessStrategy),
  tabs: [
    {
      id: 'tab_smeBusinessStrategy',
      title: 'SME Business Strategy',
      questions: smeBusinessStrategyQuestions,
      accordion: false
    }
  ]
};

export const smePerformanceConsolidationApproachTabQuestions = {
  pillarId: pillers.smePerformanceConsolidationApproach,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Environmental Performance - Consolidation Approach',
    description: `This module requests information on the method your organization 
    uses to define the boundary for reporting its climate-related impacts, such
     as greenhouse gas (GHG) emissions.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smePerformanceConsolidationApproach),
  tabs: [
    {
      id: 'tab_smePerformanceConsolidationApproach',
      title: 'SME Environmental Performance - Consolidation Approach',
      questions: smePerformanceConsolidationApproachQuestions,
      accordion: false
    }
  ]
};

export const smePerformanceClimateChangeTabQuestions = {
  pillarId: pillers.smePerformanceClimateChange,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Environmental Performance - Climate Change',
    description: `This module requests information on emissions methodologies, exclusions, 
    emissions inventory and breakdown, energy related activities, targets, and emission 
    reduction activities. The module also contains questions on allocating emissions to
     customers shown only to organizations responding to a request from a CDP Supply Chain member.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smePerformanceClimateChange),
  tabs: [
    {
      id: 'tab_smePerformanceClimateChange',
      title: 'SME Environmental Performance - Climate Change',
      questions: smePerformanceClimateChangeQuestions,
      accordion: false
    }
  ]
};

export const smeSignOffTabQuestions = {
  pillarId: pillers.smeSignOff,
  header: {
    imageUrl: GOVIcon,
    title: 'SME Sign Off',
    description: `This module requests information on the verification of the environmental 
                  information provided in the organization’s response, and organizational signoff.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpUrl(pillers.smeSignOff),
  tabs: [
    {
      id: 'tab_smeSignOff',
      title: 'SME Sign Off',
      questions: smeSignOffQuestions,
      accordion: false
    }
  ]
};
